import Addon from '../../classes/addon';
import ApiRequestManagerInstance from '../ApiRequestManager';
import { IAddonEventRequest } from '../../types/interfaces/event';
import { store } from '../../store/store';

async function addonRequest(asset: Addon) {
  const { user } = store.getState();
  const promise = new Promise<Addon | null>(async (resolve) => {
    try {
      const response: { data: IAddonEventRequest } =
        (await ApiRequestManagerInstance.get({
          endpoint: {
            url: 'apiUrl',
            section: `media${user.isAnonymous ? 'free' : ''}`,
            subsection: 'addons',
            type: 'addons',
            params: asset.addon,
          },
        })) as unknown as { data: IAddonEventRequest };
      resolve(new Addon(response.data));
    } catch (e) {
      resolve(null);
    }
  });
  return promise;
}

export default addonRequest;
